import React, { useContext, useEffect, useMemo, useState } from 'react';
import s from './styles.module.scss';
import { IcBack } from '../TradeKey/components/profileHeaderUserInfo/Icons/IcBack';
import { useRouter } from 'next/router';
import { IcMenuAction } from '../TradeKey/components/svg/ic-menu-action';
import { IHolder } from '@/interfaces/holder';
import {
  getBullBearDetal,
  getDonateDetail,
  getPlayerShareHolders,
  getPlayerTokenHolders,
  getTotalPlayerShareHolders,
} from '@/services/player-share';
import { formatCurrency, formatName } from '@/utils/string';
import CircleHolders from '../../shares-detail/Info/CircleHolders';
import { useProfiles } from '../provider';
import CircleTreasury from '@/layouts/AlphaLayout/CircleTreasury';
import { WalletContext } from '@/contexts/wallet-context';
import toast from 'react-hot-toast';
import { getUrlToSwap } from '@/utils/helpers';
import { ROUTE_PATH } from '@/constants/route-path';
import { openModal } from '@/state/modal';
import { useAppDispatch } from '@/state/hooks';
import HolderPortfolioModal, {
  HOLDER_PORTFOLIO_MODAL,
} from './HolderPortfolioModal';
import { Flex } from '@chakra-ui/react';
import { IcKeyRight } from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcKeyRight';
import { labelAmountOrNumberAdds } from '@/modules/AlphaPWA/Profiles/TradeKey/constants';
import { IcKeyLeft } from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcKeyLeft';
import IcCoin from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcIcoin';
import MenuHoldDetail from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/MenuHoldDetail';
import IconChatWhite from '../TradeKey/components/svg/IconChatWhite';
import { useDM } from '../../DirectMessage/provider';

const LIMIT_PAGE = 10000;

const HolderDetail = () => {
  const router = useRouter();
  const {
    query: { id, view },
  } = useRouter();
  const userAddress = router.query?.id as string;
  const [holders, setHolders] = useState<IHolder[]>([]);
  const { checkRoomPermission } = useDM();
  const { playerPoolProfile, playerTokenDetail, userChatRoom } = useProfiles();
  const { btc2Usd } = useContext(WalletContext);

  const fetchData = async (page = 1) => {
    let res: IHolder[] | null = null;
    const params = {
      address: userAddress || '',
      page: page,
      limit: LIMIT_PAGE,
    };
    try {
      if (view === 'circle') {
        res = await getPlayerShareHolders(params);
      } else {
        res = await getPlayerTokenHolders(params);
      }

      if (res) {
        res?.forEach(holder => {
          holder.nameHtml = `
              <div style="display: flex; align-items: center; gap:8px;">
                <img src=${holder?.user
                  ?.twitter_avatar} alt="empty" style="border-radius: 50%; width: 24px"/>
                <div>
                  ${formatName(
                    holder?.user?.twitter_name || holder?.user?.address || '',
                    30
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
              </div>
            `;
        });

        setHolders(res);
      }
    } catch (e) {
    } finally {
    }
  };

  const goToTrade = () => {
    if (playerPoolProfile) {
      router.push(
        getUrlToSwap(
          playerPoolProfile?.address || playerPoolProfile?.twitterId || ''
        )
      );
    } else {
      router.push(`${ROUTE_PATH.ALPHA_MOBILE_KEYS}`);
    }
  };

  const goToTradePassToken = () => {
    if (!playerPoolProfile?.passTokenAddress || !playerPoolProfile.address) {
      toast.error('Token address not found');
      return;
    }
    return router.push(getUrlToSwap(playerPoolProfile?.address, '', 0, true));
  };

  const goToAction = () => {
    if (view === 'circle') {
      goToTrade();
    } else {
      goToTradePassToken();
    }
  };

  const onBack = () => {
    router.back();
  };

  const goToChat = async () => {
    try {
      const checkPermission = await checkRoomPermission(
        userChatRoom[view as keyof typeof userChatRoom]
      );
      if (checkPermission) {
        const qs: {
          id: string;
          key: string;
          ownerAddress?: string;
          ownerUsername?: string;
          address?: string;
          circleAddress?: string;
        } = {
          id: userChatRoom[view as keyof typeof userChatRoom],
          key: view === 'circle' ? 'btc' : 'tribe',
          ownerAddress: playerPoolProfile?.address,
          ownerUsername: playerPoolProfile?.twitterName,
          address: playerPoolProfile?.address,
          // circleAddress: playerPoolProfile?.passTokenAddress,
        };

        if (view === 'community') {
          qs['circleAddress'] = playerPoolProfile?.passTokenAddress;
        }

        const link = `${ROUTE_PATH.ALPHA_MOBILE_DM}?${new URLSearchParams(
          qs
        ).toString()}`;

        router.push(link);
      } else {
        goToAction();
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (userAddress) {
      fetchData();
    }
  }, [userAddress]);

  return (
    <div className={s.holderWrapper}>
      <div className={s.container}>
        <div className={s.header}>
          <span className={s.back} onClick={onBack}>
            <IcBack />
          </span>
          <p className={s.viewTitle}>
            {playerPoolProfile?.twitterName} {view}
          </p>
          <span className={s.menu}>
            <span className={s.chat} onClick={goToChat}>
              <IconChatWhite />
            </span>
            <MenuHoldDetail
              address={playerPoolProfile?.address || ''}
              view={view === 'circle' ? 'CIRCLE' : 'SQUARE'}
            />
          </span>

          {/* <span className={s.dot} style={{ opacity: '0' }}>
            <IcMenuAction />
          </span> */}
        </div>
        <div className={s.body}>
          <div className={s.holderImgs}></div>
          <div className={s.holderInfo}>
            <div className={s.holderInfo__inner}>
              <div className={s.circleHolders}>
                <CircleHolders
                  data={holders}
                  type={view === 'circle' ? 'CIRCLE' : 'SQUARE'}
                />
              </div>
              <HolderInfoContent holders={holders} />
            </div>
          </div>
        </div>
      </div>
      <div className={s.holderBottom}>
        <div className={s.detail}>
          <p className={s.price}>
            $
            {view === 'community'
              ? formatCurrency(
                  btc2Usd
                    ?.multipliedBy(playerPoolProfile?.passTokenPrice || 0)
                    .toString(),
                  2,
                  2
                )
              : formatCurrency(playerTokenDetail?.usdPrice, 0, 2, 'BTC')}
          </p>
        </div>
        <button className={s.actionBtn} onClick={goToAction}>
          Buy {view === 'community' ? 'token' : 'key'}
        </button>
      </div>
    </div>
  );
};

const HolderInfoContent = ({ holders }: { holders: IHolder[] }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const {
    query: { view },
  } = useRouter();
  const userAddress = router.query?.id as string;

  const { addressL2 } = useContext(WalletContext);

  const {
    balanceTokenHolding,
    balancePassTokenHolding,
    balanceTokenHolded,
    balancePassTokenHolded,
    playerPoolProfile,
    playerTokenDetail,
    yourPoolProfile,
    isSticky,
  } = useProfiles();

  const isSelf = useMemo(() => {
    return playerPoolProfile?.address === addressL2;
  }, [playerPoolProfile, addressL2]);

  const isHadBalanceHolded = useMemo((): boolean => {
    return balanceTokenHolded > 0;
  }, [balanceTokenHolded]);

  const isHadBalanceHolding = useMemo((): boolean => {
    return balanceTokenHolding > 0;
  }, [balanceTokenHolding]);

  const isHadBalancePassTokenHolded = useMemo((): boolean => {
    return balancePassTokenHolded > 0;
  }, [balancePassTokenHolded]);

  const isHadBalancePassTokenHolding = useMemo((): boolean => {
    return balancePassTokenHolding > 0;
  }, [balancePassTokenHolding]);

  const isViewCircle = view === 'circle';

  const [totalPortfolio, setTotalPortfolio] = useState<string | null>(null);
  const [totalEvent, setTotalEvent] = useState(null);
  const [totalReward, setTotalReward] = useState(null);

  const textLabelA = useMemo(() => {
    switch (view) {
      case 'circle':
        return 'Frens';
        break;
      case 'community':
        return 'Members';
        break;
      default:
        break;
    }
  }, [view]);

  const goToShareDetail = useMemo(() => {
    switch (view) {
      case 'circle':
        return `${ROUTE_PATH.ALPHA_MOBILE_SHARES_DETAIL}/${playerPoolProfile?.address}`;
        break;
      case 'community':
        return `${ROUTE_PATH.ALPHA_MOBILE_TOKEN_HOLDERS_DETAIL}/${playerPoolProfile?.address}`;
        break;
      default:
        break;
    }
  }, [view, playerPoolProfile]);

  const textLabelB = useMemo(() => {
    switch (view) {
      case 'circle':
        return 'Treasury';
        break;
      case 'community':
        return 'Events';
        break;
      default:
        break;
    }
  }, [view]);

  const textLabelC = useMemo(() => {
    switch (view) {
      case 'circle':
        return 'Total Portfolios';
        break;
      case 'community':
        return 'Rewards';
        break;
      default:
        break;
    }
  }, [view]);

  // ====
  const valueItemA = useMemo(() => {
    switch (view) {
      case 'circle':
        return playerPoolProfile?.holders;
        break;
      case 'community':
        return holders?.length;
        break;
      default:
        return '0';
        break;
    }
  }, [view, holders, playerPoolProfile]);

  const valueItemB = useMemo(() => {
    switch (view) {
      case 'circle':
        return (
          <CircleTreasury profile={playerPoolProfile} justShowNumber={true} />
        );
        break;
      case 'community':
        return totalEvent;
        break;
      default:
        return '--';
        break;
    }
  }, [view, totalEvent, playerPoolProfile]);

  const valueItemC = useMemo(() => {
    switch (view) {
      case 'circle':
        return totalPortfolio;
        break;
      case 'community':
        return totalReward;
        break;
      default:
        return '--';
        break;
    }
  }, [view, totalReward, totalPortfolio]);

  const mintValue = useMemo(() => {
    switch (view) {
      case 'circle':
        return playerPoolProfile?.minHoldingRequirement;
        break;
      case 'community':
        return playerPoolProfile?.passTokenMinHoldingRequirement;
        break;
      default:
        return '--';
        break;
    }
  }, [playerPoolProfile, view]);

  const textRequire = useMemo(() => {
    switch (view) {
      case 'circle':
        return 'keys';
        break;
      case 'community':
        return 'tokens';
        break;
      default:
        return 'keys';
        break;
    }
  }, [view]);

  const fetchTotal = async () => {
    if (!userAddress) return null;

    try {
      const rs = await getTotalPlayerShareHolders(userAddress);

      if (rs) {
        setTotalPortfolio(rs.portfolio_value_usdt);
      }
    } catch (error: any) {}
  };

  const sumTotal = async () => {
    if (!playerPoolProfile?.passTokenAddress) return;

    try {
      const [bullBear, donate]: any = await Promise.all([
        getBullBearDetal({
          token_address: playerPoolProfile?.passTokenAddress,
          twitter_id: playerPoolProfile?.twitterId,
        }),
        getDonateDetail(playerPoolProfile?.passTokenAddress),
      ]);

      const sumEvent = (bullBear?.event || 0) + (donate?.event || 0);
      const sumReward = (bullBear?.reward || 0) + (donate?.reward || 0);

      setTotalEvent(sumEvent);
      setTotalReward(sumReward);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userAddress && playerPoolProfile) {
      if (view === 'circle') {
        fetchTotal();
      } else {
        sumTotal();
      }
    }
  }, [userAddress, view, router, playerPoolProfile]);

  return (
    <>
      <div className={s.holderInfo__content}>
        {/* ===  ITEM 1 === */}
        <div
          className={s.item}
          onClick={e => {
            e.stopPropagation();
            router.push(goToShareDetail || '');
          }}
        >
          <p className={s.num}>{valueItemA}</p>
          <p className={s.des}>{textLabelA}</p>
        </div>
        {/* ===  ITEM 2 === */}
        <div className={s.item}>
          <p className={s.num}> {valueItemB}</p>
          <p className={s.des}>{textLabelB}</p>
        </div>
        {/* ===  ITEM 3 === */}
        <div
          className={s.item}
          onClick={() => {
            if (view === 'circle') {
              dispatch(
                openModal({
                  id: HOLDER_PORTFOLIO_MODAL,
                  theme: 'dark',
                  title: '',
                  modalProps: {
                    centered: true,
                    zIndex: 9999999,
                  },
                  render: () => (
                    <HolderPortfolioModal
                      holders={holders}
                      playerPoolProfile={playerPoolProfile}
                    />
                  ),
                })
              );
            }
          }}
        >
          <p className={s.num}>${formatCurrency(valueItemC, 0, 2)}</p>
          <p className={s.des}>{textLabelC}</p>
        </div>
      </div>
      <div className={s.holderInfo__note}>
        <p>
          Need {formatCurrency(mintValue, 0, 2)}{' '}
          <b>{playerPoolProfile?.twitterName}</b> {textRequire} to join {view}
        </p>
      </div>

      {isViewCircle ? (
        <>
          {isHadBalanceHolding && (
            <Flex className={s.keys_infos} alignItems={'center'} gap={4}>
              <IcKeyRight />
              <div className={s.keys_infos_text}>
                {`You have `}
                <b>{formatCurrency(balanceTokenHolding, 0, 5)}</b>
                {` ${
                  playerPoolProfile?.twitterName ||
                  playerPoolProfile?.twitterUsername
                } key${labelAmountOrNumberAdds(balanceTokenHolding)}.`}
              </div>
            </Flex>
          )}

          {isHadBalanceHolded && !isSelf && (
            <Flex className={s.keys_infos} alignItems={'center'} gap={4}>
              <IcKeyRight />
              <div className={s.keys_infos_text}>
                {`${
                  playerPoolProfile?.twitterName ||
                  playerPoolProfile?.twitterUsername
                }  has `}
                <b>{formatCurrency(balanceTokenHolded, 0, 5)}</b>
                {` ${
                  yourPoolProfile?.twitterName ||
                  yourPoolProfile?.twitterUsername
                } key${labelAmountOrNumberAdds(balanceTokenHolded)}.`}
              </div>
            </Flex>
          )}
        </>
      ) : (
        <>
          {isHadBalancePassTokenHolding && (
            <Flex className={s.keys_infos} alignItems={'center'} gap={4}>
              <IcCoin />
              <div className={s.keys_infos_text}>
                {`You have `}
                <b>{formatCurrency(balancePassTokenHolding, 0, 5)}</b>
                {` ${
                  playerPoolProfile?.twitterName ||
                  playerPoolProfile?.twitterUsername
                } token${labelAmountOrNumberAdds(balancePassTokenHolding)}.`}
              </div>
            </Flex>
          )}

          {isHadBalancePassTokenHolded && !isSelf && (
            <Flex className={s.keys_infos} alignItems={'center'} gap={4}>
              <IcCoin />
              <div className={s.keys_infos_text}>
                {`${
                  playerPoolProfile?.twitterName ||
                  playerPoolProfile?.twitterUsername
                }  has `}
                <b>{formatCurrency(balancePassTokenHolded, 0, 5)}</b>
                {` ${
                  yourPoolProfile?.twitterName ||
                  yourPoolProfile?.twitterUsername
                } token${labelAmountOrNumberAdds(balancePassTokenHolded)}.`}
              </div>
            </Flex>
          )}
        </>
      )}
    </>
  );
};

export default HolderDetail;
